import React from 'react';
import { TourDetailPage } from '../components/TourDetailPage';
import { indonesiaTours } from '../data/tours';

export const CoffeeTourPage = () => {
  const tour = indonesiaTours.find(t => t.id === 'coffee-civilization');
  return <TourDetailPage tour={tour} />;
};
